export const interests = [
  "Food & Beverages",
  "Sports & Fitness",
  "Fashion",
  "Luxury",
  "Entertainment",
  "Kids & Maternity",
  "Technology",
  "Travel",
  "Education",
  "Home & Living",
  "Beauty & Personal Care",
  "Health & Wellness",
];
